import { useAppDispatch } from '@/state/hooks';
import { setWorkspaceTabEnlargedModule } from '@/state/reducers/workspaceSlice';
import useXplorSpotLayout from '@/utils/hooks/useXplorSpotLayout';
import useXplorTraderLayout from '@/utils/hooks/useXplorTraderLayout';
import { useScreenSizes } from '@/utils/providers/ScreenSizesProvider';
import { Fragment, useCallback, useMemo } from 'react';
import { FaCompress, FaExpand } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { MosaicContext, MosaicWindowContext } from 'react-mosaic-component';
import { useLocation } from 'react-router-dom';

const ModuleWindowControls = (props: any) => {
    const { id, onClose } = props;

    const dispatch = useAppDispatch();

    const location = useLocation();
    const screen = useScreenSizes();

    const { workspace: xplorSpotWorkspace } = useXplorSpotLayout();
    const { workspace: xplorTraderWorkspace } = useXplorTraderLayout();

    const isEnlarged = useMemo(() => {
        const workspace = location.pathname.includes('/trader') ? xplorTraderWorkspace : xplorSpotWorkspace;
        return workspace.enlargedModule === id;
    }, [location, xplorSpotWorkspace.enlargedModule, xplorTraderWorkspace.enlargedModule, id]);

    const workspaceType = useMemo(
        () => (location.pathname.includes('/trader') ? 'xplortrader' : 'xplorspot'),
        [location]
    );

    const handleFullscreen = useCallback((id) => {
        dispatch(setWorkspaceTabEnlargedModule(id));
        // const elem = document.getElementById(id);
        // launchFullscreen(elem);
    }, []);

    return (
        <div className="h-full flex items-center">
            {(screen.laptop || screen.desktop) && (
                <MosaicContext.Consumer>
                    {({ mosaicActions, blueprintNamespace }) => (
                        <MosaicWindowContext.Consumer>
                            {({ mosaicWindowActions, blueprintNamespace }) => (
                                <Fragment>
                                    {!isEnlarged ? (
                                        <div
                                            title="Expand Section"
                                            className="cursor-pointer hover:bg-brand-primary p-2 ml-2 rounded-sm flex items-center"
                                            onClick={() => {
                                                dispatch(setWorkspaceTabEnlargedModule({ workspaceType, id }));
                                            }}>
                                            <FaExpand />
                                        </div>
                                    ) : (
                                        <div
                                            title="Compress Section"
                                            className="cursor-pointer hover:bg-brand-primary p-2 ml-2 mr-1 rounded-sm flex items-center"
                                            onClick={() => {
                                                dispatch(setWorkspaceTabEnlargedModule({ workspaceType }));
                                            }}>
                                            <FaCompress />
                                        </div>
                                    )}
                                    {!isEnlarged && (
                                        <div
                                            title="Close Section"
                                            className="cursor-pointer hover:bg-brand-primary p-2 mx-1 rounded-sm flex items-center"
                                            onClick={() => {
                                                mosaicActions.remove(mosaicWindowActions.getPath());
                                                onClose?.();
                                            }}>
                                            <MdClose />
                                        </div>
                                    )}
                                </Fragment>
                            )}
                        </MosaicWindowContext.Consumer>
                    )}
                </MosaicContext.Consumer>
            )}
        </div>
    );
};

export default ModuleWindowControls;
